import React, { useEffect, useMemo, useRef, useState } from "react"
import "./formNotification.css"
import axios from "axios";

const formatDate = (value) => {
    const date = parseDateValue(value);
    if (!date) return value ? String(value) : '';

    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

const parseDateValue = (value) => {
    if (!value) return null;

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const text = String(value).trim();

    // Handle common backend formats like DD/MM/YYYY or DD-MM-YYYY.
    const dateOnlyMatch = text.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})(?:\s+.*)?$/);
    if (dateOnlyMatch) {
        const [, day, month, year] = dateOnlyMatch;
        const parsed = new Date(Number(year), Number(month) - 1, Number(day));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(text);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const getDateKey = (value) => {
    const date = parseDateValue(value);
    if (!date) return '';

    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).toDateString();
};

const getItemDate = (item) => item?.followupdate || item?.date || item?.lastfollowupdate || '';

const getItemComment = (item) =>
    item?.comment || item?.remarks || item?.notes || item?.interestshown || '';

const getItemContactNumber = (item) =>
    String(item?.contactpersonnumber || item?.contactNumber || item?.contactnumber || '')
        .trim()
        .replace(/\D/g, '');

const FormNotification = ({ onInstituteClick }) => {
    const [showNotification, setShowNotification] = useState(false);
    const [followupdata, setFollowupdata] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const buttonRef = useRef(null);
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showNotification &&
                popupRef.current &&
                !popupRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowNotification(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showNotification]);

    useEffect(() => {
        if (!showNotification) return;

        const loadFollowups = async () => {
            try {
                const empId = localStorage.getItem('empId');

                const requests = [
                    axios.get("https://cleezoclass.com:8443/api/pending-followups"),
                ];

                if (empId) {
                    requests.push(
                        axios.get(`https://cleezoclass.com:8443/api/todays-followups/${empId}`)
                    );
                }

                const responses = await Promise.all(requests);
                const pendingFollowups = Array.isArray(responses[0]?.data) ? responses[0].data : [];
                const todaysFollowups = Array.isArray(responses[1]?.data) ? responses[1].data : [];

                const merged = [...todaysFollowups, ...pendingFollowups];
                const unique = [];
                const seen = new Set();

                merged.forEach((item) => {
                    const contactNumber = getItemContactNumber(item);
                    const key = [
                        contactNumber || item?.institutename || '',
                        contactNumber,
                    ].join('|').toLowerCase();

                    if (!seen.has(key)) {
                        seen.add(key);
                        unique.push(item);
                    }
                });

                setFollowupdata(unique);
            } catch (err) {
                console.log("ERROR:", err);
                setFollowupdata([]);
            }
        };

        loadFollowups();
    }, [showNotification])

    console.log("Notification bar", followupdata)
    console.log("searchTeam", searchTerm)

    const handlenotifications = () => {
        setShowNotification(prev => !prev)
    }
    

    const groupedFollowups = useMemo(() => {
        const today = new Date();
        const todayKey = today.toDateString();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const yesterdayKey = yesterday.toDateString();

        const items = Array.isArray(followupdata) ? [...followupdata] : [];

        items.sort((a, b) => {
            const dateA = parseDateValue(getItemDate(a))?.getTime() || 0;
            const dateB = parseDateValue(getItemDate(b))?.getTime() || 0;
            return dateB - dateA;
        });

        const groups = {
            today: [],
            yesterday: [],
            earlier: [],
        };

        items.forEach((item) => {
            const itemKey = getDateKey(getItemDate(item));
            if (itemKey === todayKey) {
                groups.today.push(item);
            } else if (itemKey === yesterdayKey) {
                groups.yesterday.push(item);
            } else {
                groups.earlier.push(item);
            }
        });

        return groups;
    }, [followupdata]);

    const filteredGroupedFollowups = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();

        if (!term) {
            return groupedFollowups;
        }

        const matches = (item) => {
            const searchableText = [
                item?.institutename,
                getItemComment(item),
                getItemDate(item) ? formatDate(getItemDate(item)) : '',
                getItemContactNumber(item),
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

            return searchableText.includes(term);

        };

        return {
            today: groupedFollowups.today.filter(matches),
            yesterday: groupedFollowups.yesterday.filter(matches),
            earlier: groupedFollowups.earlier.filter(matches),
        };
    }, [groupedFollowups, searchTerm]);

    const hasVisibleItems =
        filteredGroupedFollowups.today.length > 0 ||
        filteredGroupedFollowups.yesterday.length > 0 ||
        filteredGroupedFollowups.earlier.length > 0;


    return (
        
            <div className="notificationBtn">
                <button ref={buttonRef} className='form-followup-notification' onClick={handlenotifications}><i className="fa-regular fa-bell"></i>
                </button>
                {showNotification && (
                   <div className="notificationPopup" ref={popupRef}>
                        <h4>Pending Followups</h4>
                        <input
                            className="notification-search"
                            type="text"
                            placeholder="Search follow-ups..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <div>
                            {Array.isArray(followupdata) && followupdata.length > 0 ? (
                                <>
                                    {!hasVisibleItems && <p>No matching follow ups</p>}

                                    {filteredGroupedFollowups.today.length > 0 && (
                                        <>
                                            <h5>Today</h5>
                                            {filteredGroupedFollowups.today.map((item, index) => (
                                                <div className="popup-items" key={`today-${index}`}>
                                                    <span
                                                        className="notification-institute-link"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => onInstituteClick?.(item)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                onInstituteClick?.(item);
                                                            }
                                                        }}
                                                    >
                                                        {item.institutename}
                                                    </span>
                                                    <span className="notification-item-meta">
                                                        {getItemDate(item) ? ` - ${formatDate(getItemDate(item))}` : ''}
                                                        {getItemComment(item) ? ` - ${getItemComment(item)}` : ''}
                                                    </span>
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    {filteredGroupedFollowups.yesterday.length > 0 && (
                                        <>
                                            <h5>Yesterday</h5>
                                            {filteredGroupedFollowups.yesterday.map((item, index) => (
                                                <div className="popup-items" key={`yesterday-${index}`}>
                                                    <span
                                                        className="notification-institute-link"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => onInstituteClick?.(item)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                onInstituteClick?.(item);
                                                            }
                                                        }}
                                                    >
                                                        {item.institutename}
                                                    </span>
                                                    <span className="notification-item-meta">
                                                        {getItemDate(item) ? ` - ${formatDate(getItemDate(item))}` : ''}
                                                        {getItemComment(item) ? ` - ${getItemComment(item)}` : ''}
                                                    </span>
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    {filteredGroupedFollowups.earlier.length > 0 && (
                                        <>
                                            <h5>Earlier</h5>
                                            {filteredGroupedFollowups.earlier.map((item, index) => (
                                                <div className="popup-items" key={`earlier-${index}`}>
                                                    <span
                                                        className="notification-institute-link"
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => onInstituteClick?.(item)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                onInstituteClick?.(item);
                                                            }
                                                        }}
                                                    >
                                                        {item.institutename}
                                                    </span>
                                                    <span className="notification-item-meta">
                                                        {getItemDate(item) ? ` - ${formatDate(getItemDate(item))}` : ''}
                                                        {getItemComment(item) ? ` - ${getItemComment(item)}` : ''}
                                                        {getItemContactNumber(item) ? `-${getItemContactNumber(item)}` : ""}
                                                    </span>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </>
                            ) : (
                                <p>No pending follow ups</p>
                            )}
                        </div>
                    </div>
                )}
            </div>

    );
}
export default FormNotification;
